import { createContext } from 'react';

import { DataModelAttribute } from '@/types/DataModel';

interface FocusAttributeContextType {
  focusAttribute: DataModelAttribute | undefined;
  setFocusAttribute: React.Dispatch<React.SetStateAction<DataModelAttribute | undefined>>;
  /** Set only when the user focuses a field or picks one from search. */
  pinnedAttributeName: string | undefined;
  setPinnedAttributeName: React.Dispatch<React.SetStateAction<string | undefined>>;
  sectionOpen: boolean;
  setSectionOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FocusAttributeContext = createContext<FocusAttributeContextType | undefined>(undefined);

